module.exports = __webpack_public_path__ + "img/627.2ce64e17.jpg";